import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58ef120e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resource-map-ctn flex-column" }
const _hoisted_2 = { class: "ml_div" }
const _hoisted_3 = { class: "map-ctn" }

import { onBeforeUnmount, onMounted, ref, watch, onActivated } from "vue"
import MapMain from "@/layout/mapMain/index.vue"
import Cities from "@/components/CitiesAll.vue"
import config from "@/modules/appConfig"
import debounce from "lodash-es/debounce"
import { getModules } from "@/modules/arcgisAPI"
import { useMapStore } from "@/store/modules/map"
import { queryTask, changeExtent, charCount, polyonOffset } from "@/utils/commons"
import { dicAPi } from "@/api/login"
import { addFeedBackApi } from "@/api/home"
import { getResourceMap } from "@/api/resource"
import { showLoadingToast, showSuccessToast, showFailToast } from "vant"
import { getNoLoginCityCodeHome } from "@/utils/cookies"
import router from "@/router"
import { useRoute } from "vue-router"
import { isArray } from "lodash-es"

export default /*#__PURE__*/_defineComponent({
  __name: 'map',
  setup(__props) {

const route = useRoute()
const mapStore = useMapStore()
const areaRef = ref()
const searchValue = ref("")
const city = ref(getNoLoginCityCodeHome() || "")
const type = ref("")
let layer: any = null
let watchEvent: any = null
let clickEvent: any = null
let pointLayer: any = null
let sourceLayer: any = null
let staticLayer: any = null
let lineLayer: any = null
const option2: any = ref([])
let pointList: any = []
let cityStatic: any = []
let regionStatic: any = []
const searchTpye = ref("")
let landLayer: any = null
// let graphicLine: any = null
let selectGeometry: any = null

onActivated(() => {
  city.value = getNoLoginCityCodeHome() || ""
  config.changeView(config.mapView)
  // if (route.meta.isReach) {
  //   alert("刷新")
  //   //  刷新界面
  //   initData()
  // } else {
  //   alert("不刷新")
  // }
})
onMounted(() => {
  getAllDict() //获取字典
  // 判断是否登录，没有登录获取缓存信息给city赋值
  // if (getNoLoginCityCodeHome()) {
  //   city.value = getNoLoginCityCodeHome() || ""
  // }
})
// 从首页进进行重载，回退的话，不刷新
router.beforeEach((to: any, form: any) => {
  if (to.path === "/resource/map" && form.path === "/home") {
    initData()
  }
})
// 获取字典
const getAllDict = async () => {
  const res: any = await dicAPi("resource_type")
  if (res.code == 200) {
    option2.value = []
    res.data.map((item: any) => {
      let object = {
        text: item.name,
        value: item.code
      }
      option2.value.push(object)
    })
  }
}
const onSearch = debounce(() => {
  getData()
}, 500) // 防抖时间为500毫秒
const onClear = () => {
  // 重新搜索
  getData()
}

const change = () => {
  getData()
}
const resetData = async () => {
  pointList = []
  if (sourceLayer) {
    sourceLayer.visible = false
  }
  config.activeView.graphics.removeAll()
  const [GraphicsLayer] = await getModules(["esri/layers/GraphicsLayer"])
  if (!lineLayer) {
    lineLayer = new GraphicsLayer()
    config.activeView.map.add(lineLayer)
  } else {
    lineLayer.removeAll()
  }
  if (!pointLayer) {
    pointLayer = new GraphicsLayer({
      visible: false
    })
    config.activeView.map.add(pointLayer)
  } else {
    pointLayer.removeAll()
  }
  if (!staticLayer) {
    staticLayer = new GraphicsLayer({
      visible: false
    })
    config.activeView.map.add(staticLayer)
  } else {
    staticLayer.removeAll()
  }
  if (!landLayer) {
    landLayer = new GraphicsLayer()
    config.activeView.map.add(landLayer)
  } else {
    landLayer.removeAll()
  }
}
// 获取查询数据
const getData = async () => {
  resetData()
  const params: any = {
    zymc: searchValue.value,
    lx: type.value
  }

  const data = mapStore.xzqhbm
  const code = data.code
  params.xzqhbm = code

  showLoadingToast({
    message: "查询中",
    duration: 0
  })
  getResourceMap(params)
    .then(async (res: any) => {
      if (res && res.sucess) {
        showSuccessToast({
          message: "已查到相关数据",
          duration: 2000
        })
        const records = res.data.records
        if (records.length > 0) {
          const [Polygon, Graphic] = await getModules(["esri/geometry/Polygon", "esri/Graphic"])
          records.forEach(async (ele: any) => {
            const geojson = ele.geom || ele.geojson
            if (geojson && geojson != null) {
              const geojsonG = JSON.parse(geojson)
              const polygon = new Polygon({
                rings: geojsonG.coordinates,
                spatialReference: config.activeView.spatialReference
              })

              pointList.push(
                new Graphic({
                  geometry: polygon.centroid,
                  attributes: {
                    ObjectID: ele.sfid,
                    id: ele.sfid,
                    zymc: ele.zymc,
                    type: "地块"
                  }
                })
              )
              const fillSymbol = {
                type: "simple-fill",
                color: [227, 139, 79, 0.2],
                outline: {
                  color: [0, 255, 255, 1],
                  width: 2
                }
              }
              const graphic = new Graphic({
                geometry: polygon,
                symbol: fillSymbol,
                attributes: { ...ele, type: "地块", geometry: polygon }
              })
              const strCount = charCount(ele.zymc)
              let fieldName = ele.zymc
              if (strCount > 20) {
                fieldName = ele.zymc.slice(20) + "···"
              }
              const widthLength = 17 * (strCount > 20 ? 21 : strCount)
              const imageUrl = await createImage(fieldName, widthLength, 33)
              const graphicText = new Graphic({
                geometry: polygon.centroid,
                symbol: {
                  type: "picture-marker",
                  width: widthLength + "px",
                  height: "33px",
                  url: imageUrl,
                  outline: {
                    color: [255, 255, 255],
                    width: 0
                  }
                },
                attributes: { ...ele, type: "地块", geometry: polygon }
              })
              pointLayer.add(graphic)
              pointLayer.add(graphicText)
            }
          })
          if (searchTpye.value === "全国") {
            showSourceLayer()
          } else {
            initStatics(records)
          }
        } else {
          showFailToast({
            message: "未找到相关数据",
            duration: 2000
          })
        }
      }
    })
    .finally(() => {
      // closeToast()
    })
}
const initStatics = async (records: any) => {
  if (!config.activeView) return
  cityStatic = []
  regionStatic = []

  // 区级服务
  const url = (window as any).xzqh + "/4"
  const xzqhField = (window as any).shiField

  const data = mapStore.xzqhbm
  let code = data.code.slice(0, 4)
  const where: any = []
  where.push(`${xzqhField} = ${code + "00"}`)
  const params = {
    where: where.join(" and "),
    outFields: ["*"],
    returnGeometry: true
  }
  const res: any = await queryTask(url, params)
  const resCity: any = await queryTask((window as any).xzqh + "/5", {
    where: `${xzqhField} = ${code + "00"}`,
    outFields: ["*"],
    returnGeometry: true
  })
  const [Graphic] = await getModules(["esri/Graphic"])
  // 统计市级的数量
  if (resCity && resCity.length) {
    const geometry = resCity[0].geometry
    selectGeometry = geometry
    const count = records.length
    const imageUrl = await createImage([resCity[0].attributes["市名"], count + "个"], 90, 50)
    const graphicText = new Graphic({
      geometry: geometry.centroid,
      symbol: {
        type: "picture-marker",
        width: "90px",
        height: "50px",
        url: imageUrl,
        outline: {
          color: [255, 255, 255],
          width: 0
        }
      },
      attributes: {
        type: "城市",
        geometry,
        count
      },
      visible: false
    })
    cityStatic.push(graphicText)
  }
  // 统计区县的数量
  if (res && res.length) {
    let newRecords: any = {}
    records.forEach((item: any) => {
      if (newRecords[item.xzqhbm]) {
        newRecords[item.xzqhbm] += 1
      } else {
        newRecords[item.xzqhbm] = 1
      }
    })

    res.forEach(async (ele: any) => {
      let count = 0
      if (ele.attributes["县代码"] in newRecords) {
        count = newRecords[ele.attributes["县代码"]]
      }
      const widthLength = 25 * charCount(ele.attributes["县名"])
      const imageUrl = await createImage([ele.attributes["县名"], count + "个"], widthLength, 50)
      const graphicText1 = new Graphic({
        geometry: ele.geometry.centroid,
        symbol: {
          type: "picture-marker",
          width: widthLength + "px",
          height: "50px",
          url: imageUrl,
          outline: {
            color: [255, 255, 255],
            width: 0
          }
        },
        attributes: {
          type: "区县",
          geometry: ele.geometry,
          count,
          name: ele.attributes["县名"],
          code: ele.attributes["县代码"]
        },
        visible: false
      })
      regionStatic.push(graphicText1)
    })
    Promise.resolve().then(() => {
      staticLayer.visible = true
      staticLayer.addMany(cityStatic)
      staticLayer.addMany(regionStatic)
      if (searchTpye.value === "城市") {
        cityStatic.forEach((city: any) => {
          city.visible = true
        })
      } else {
        regionStatic.forEach((region: any) => {
          region.visible = true
        })
        const item = regionStatic.filter((ele: any) => {
          if (ele.attributes.code === data.code) {
            selectGeometry = ele.attributes.geometry
            return true
          }
        })
        drawArea(item[0])
      }
      drawLine()
    })
  }
}

const showSourceLayer = async () => {
  if (!sourceLayer) {
    const [FeatureLayer] = await getModules(["esri/layers/FeatureLayer"])
    sourceLayer = new FeatureLayer({
      id: "sourceLayer",
      objectIdField: "ObjectID",
      outFields: ["*"],
      fields: [
        { name: "id", type: "string" },
        { name: "zymc", type: "string" }
      ],
      geometryType: "point",
      source: pointList,
      // url,
      renderer: {
        type: "simple",
        // symbol: {
        //   type: "simple-marker",
        //   size: 15,
        //   color: "rgba(255, 205, 1, 0.85)",
        //   outline: {
        //     color: "rgba(255, 205, 1, 0.5)",
        //     width: 8
        //   }
        // }

        symbol: {
          type: "picture-marker",
          url: "/static/images/cluster-point.png",
          width: "21px",
          height: "30px"
        }
      },
      featureReduction: {
        type: "cluster",
        clusterRadius: "40px",
        clusterMinSize: "40px",
        clusterMaxSize: "40px",
        // symbol: {
        //   type: "simple-marker",
        //   style: "circle",
        //   color: "rgba(0, 116, 112, 0.7)",
        //   outline: {
        //     color: "rgba(0, 116, 112, 0.3)",
        //     width: 5
        //   }
        // },
        labelingInfo: [
          {
            deconflictionStrategy: "none",
            labelExpressionInfo: {
              expression: "$feature.cluster_count"
            },
            symbol: {
              type: "text",
              color: "#cba407",
              font: {
                weight: "bold",
                family: "Noto Sans",
                size: "14px"
              },
              yoffset: 5
            },
            labelPlacement: "center-center"
          }
        ]
      },
      visible: true
    })
    config.activeView.map.add(sourceLayer)
  } else {
    sourceLayer.visible = true
    sourceLayer.refresh()
  }
}

const initMapEvent = () => {
  if (!mapStore.loading2dFinish) return
  if (!watchEvent) {
    watchEvent = config.activeView.watch("scale", (scaleValue: any) => {
      // 当放大到一定程度，展示资源地图
      if (searchTpye.value === "全国") {
        if (sourceLayer && pointLayer) {
          if (scaleValue >= 20000) {
            sourceLayer.visible = true
            pointLayer.visible = false
            landLayer.visible = false
          } else {
            sourceLayer.visible = false
            pointLayer.visible = true
            landLayer.visible = true
          }
        }
      } else {
        if (pointLayer) {
          if (scaleValue >= 1180000) {
            cityStatic.forEach((city: any) => {
              city.visible = true
            })
            regionStatic.forEach((region: any) => {
              region.visible = false
            })
            staticLayer.visible = true
            pointLayer.visible = false
            landLayer.visible = false
          } else if (scaleValue >= 150000) {
            cityStatic.forEach((city: any) => {
              city.visible = false
            })
            regionStatic.forEach((region: any) => {
              region.visible = true
            })
            staticLayer.visible = true
            pointLayer.visible = false
            landLayer.visible = false
          } else {
            staticLayer.visible = false
            pointLayer.visible = true
            landLayer.visible = true
          }
        }
      }
    })
  }
  if (!clickEvent) {
    clickEvent = config.activeView.on("click", (event: any) => {
      config.activeView.hitTest(event).then((response: any) => {
        if (response && response.results.length) {
          for (var i = 0; i < response.results.length; i++) {
            const graphic = response.results[i]
            if (graphic.graphic.attributes) {
              //记录浏览量
              const ids = graphic.graphic.attributes.sfid
              var datas = {
                originalSfid: ids,
                type: "resource"
              }
              addFeedBackApi(datas).then(() => {})

              const { type, geometry, name } = graphic.graphic.attributes
              if (type === "城市") {
                if (geometry) {
                  config.activeView.extent = changeExtent(geometry.extent.clone())
                }
                cityStatic.forEach((city: any) => {
                  city.visible = false
                })
                regionStatic.forEach((region: any) => {
                  region.visible = true
                })
                staticLayer.addMany(regionStatic)
                drawLine()
              } else if (type === "区县") {
                const item = regionStatic.filter((ele: any) => {
                  if (ele.attributes && ele.attributes.name === name) {
                    selectGeometry = ele.attributes.geometry
                    return true
                  }
                })
                drawArea(item[0])
                drawLine()
              } else if (type === "地块") {
                dealLand(graphic.graphic.attributes)
                const ids = graphic.graphic.attributes.sfid
                router.push({ path: "/resource/detail", query: { id: ids } })
              }
            }
          }
        }
      })
    })
  }
}

//画选中的区县标识
const drawArea = async (item: any) => {
  regionStatic = regionStatic.filter((ele: any) => {
    return ele.name !== "area-active"
  })
  const delList: any = []
  staticLayer.graphics.forEach((ele: any) => {
    if (ele.name === "area-active") {
      delList.push(ele)
    }
  })
  staticLayer.removeMany(delList)

  const { name, count, geometry } = item.attributes
  const widthLength = 25 * charCount(name)
  const imageUrl = await createImage([name, count + "个"], widthLength, 50, "rgb(247, 49, 49)")
  const [Graphic] = await getModules(["esri/Graphic"])
  const graphicText = new Graphic({
    name: "area-active",
    geometry: geometry.centroid,
    symbol: {
      type: "picture-marker",
      width: widthLength + "px",
      height: "50px",
      url: imageUrl,
      outline: {
        color: [255, 255, 255],
        width: 0
      }
    }
  })
  regionStatic.push(graphicText)
  staticLayer.add(graphicText)
}

// 画边界线
const drawLine = async () => {
  if (lineLayer) {
    lineLayer.removeAll()
  }

  const symbol = {
    type: "simple-fill",
    color: [255, 205, 1, 0.15],
    outline: {
      color: [255, 205, 1],
      width: 1
    }
  }
  const [Graphic] = await getModules(["esri/Graphic"])
  const graphicLine = new Graphic({ symbol, geometry: selectGeometry })
  lineLayer.add(graphicLine)
  if (selectGeometry) {
    config.activeView.extent = changeExtent(selectGeometry.extent.clone())
  }
}

// 画选中地块
const dealLand = async (info: any) => {
  const { geometry, zymc } = info
  const delList: any = []
  landLayer.graphics.forEach((item: any) => {
    if (item.name === "select-land") {
      delList.push(item)
    }
    if (item.name === "text-land") {
      delList.push(item)
    }
  })
  landLayer.removeMany(delList)

  const fillSymbol = {
    type: "simple-fill",
    color: [247, 49, 49, 0.3],
    outline: {
      color: [247, 49, 49, 1],
      width: 2
    }
  }
  const [Graphic] = await getModules(["esri/Graphic"])
  const selectland = new Graphic({
    geometry,
    symbol: fillSymbol,
    name: "select-land"
  })

  const widthLength = 17 * charCount(zymc)
  const imageUrl = await createImage(zymc, widthLength, 33, "rgb(247, 49, 49)")
  const graphicText = new Graphic({
    name: "text-land",
    geometry: geometry.centroid,
    symbol: {
      type: "picture-marker",
      width: widthLength + "px",
      height: "33px",
      url: imageUrl,
      outline: {
        color: [255, 255, 255],
        width: 0
      }
    }
  })
  landLayer.add(selectland)
  landLayer.add(graphicText)

  // 定位到图形时添加偏移
  config.activeView.extent = changeExtent(geometry.extent.clone())
  const screenPoint = config.activeView.toScreen(geometry.centroid)
  screenPoint.y += 300 // 向上偏移200像素
  const mapPoint = config.activeView.toMap(screenPoint)
  config.activeView.goTo({
    target: mapPoint,
    scale: 2000
  })
}

/**
 * 生成带文字的图片
 */
const createImage = (text: any, width = 100, height = 33, color = "#ffcd01") => {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas")
    canvas.width = width
    canvas.height = height
    const ctx: any = canvas.getContext("2d")
    ctx.font = "bold 15px Arial"

    ctx.fillStyle = color
    //画圆角 (位置x,位置y,宽度，高度)
    ctx.roundRect(0, 0, width, height, 10)
    ctx.fill()
    ctx.textAlign = "center"
    ctx.textBaseline = "middle"
    ctx.fillStyle = "#fff"
    if (isArray(text)) {
      text.forEach((item: any, index: number) => {
        ctx.fillText(item, canvas.width / 2, index === 0 ? 16 : 36)
      })
    } else {
      ctx.fillText(text, canvas.width / 2, canvas.height / 2)
    }

    resolve(canvas.toDataURL("image/png"))
  })
}

watch(
  () => mapStore.loading2dFinish,
  (value) => {
    if (value) {
      initMapEvent()
      initData()
    }
  }
)

watch(
  () => mapStore.xzqhbm,
  (value) => {
    if (value) {
      initData()
    }
  }
)

const initData = () => {
  const data = mapStore.xzqhbm
  searchTpye.value = "全国"
  if (mapStore.loading2dFinish) {
    if (data.searchTpye === "城市") {
      searchTpye.value = "城市"
    } else if (data.searchTpye === "区县") {
      searchTpye.value = "区县"
    }
    getData()
  }
}

// onBeforeUnmount(() => {
// if (layer) {
//   config.activeView.map.remove(layer)
//   layer = null
// }
// if (clickEvent) {
//   clickEvent.remove()
//   clickEvent = null
// }
// if (clickEvent) {
//   clickEvent.remove()
//   clickEvent = null
// }
// })

const onChange = () => {
  // 需要判断是新增还是编辑，再记录用户定位参数
  // 未登录进行缓存
  const newCode = city.value.indexOf(",")
  sessionStorage.setItem("noLogincityCodeHome", city.value.substring(0, newCode))
}

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      modelValue: searchValue.value,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
        _unref(onSearch)
      ],
      "show-action": "",
      placeholder: "请输入搜索关键词",
      onSearch: _unref(onSearch),
      onClear: onClear,
      onCancel: onClear
    }, {
      action: _withCtx(() => [
        _createElementVNode("div", {
          class: "",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSearch) && _unref(onSearch)(...args)))
        }, "搜索")
      ]),
      _: 1
    }, 8, ["modelValue", "onSearch", "onUpdate:modelValue"]),
    _createVNode(_component_van_dropdown_menu, { style: {"position":"relative"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Cities, {
            city: city.value,
            "onUpdate:city": _cache[2] || (_cache[2] = ($event: any) => ((city).value = $event)),
            level: 3,
            labelName: '区域',
            isOpen: _unref(getNoLoginCityCodeHome)() ? true : false,
            onChange: onChange
          }, null, 8, ["city", "isOpen"])
        ]),
        _createVNode(_component_van_dropdown_item, {
          modelValue: city.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((city).value = $event)),
          title: "区域",
          ref_key: "areaRef",
          ref: areaRef
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_dropdown_item, {
          modelValue: type.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((type).value = $event)),
          title: "类型",
          options: option2.value,
          onChange: change
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(MapMain)
    ])
  ]))
}
}

})